// Port of api/fuel/app/classes/insights/plays/played.php
// NOTE: The PHP version uses Filter::search() and Filter::package().
// Since the offline filter engine is not fully wired up as a callable API,
// this port uses direct SQL to replicate the same result.
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'played',
    insight: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var played = []
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var limit = detail ? 100 : 5

        var sqlPlayers = ''
        if (players) {
            sqlPlayers = ' AND p.play_players >= ' + players + ' AND p.play_players <= ' + players
        }

        // Get top played games in the date range, sorted by total plays desc
        var playedRows = Util.queryFast(
            'SELECT p.game_id,' +
            ' SUM(p.play_count) AS plays,' +
            ' MAX(p.play_date) AS play_last' +
            ' FROM play p' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date <= ' + (range.end - 1) +
            sqlPlayers +
            ' GROUP BY p.game_id' +
            ' ORDER BY SUM(p.play_count) DESC, p.game_id ASC' +
            ' LIMIT ' + limit
        )

        if (playedRows.length) {

            var gameIds = Util.pluck(playedRows, 'game_id')

            if (!gameIds.length) gameIds = [0]

            // Get average ratings for these games
            var ratings = Util.queryFast(
                'SELECT r.game_id, AVG(r.rating_value) AS rating_avg' +
                ' FROM rating r' +
                ' WHERE r.game_id IN(' + Util.in(gameIds) + ')' +
                ' AND r.user_id IN(' + Util.in(userIndex) + ')' +
                ' GROUP BY r.game_id',
                null, 'game_id'
            )

            for (var i = 0; i < playedRows.length; i++) {
                var row = playedRows[i]
                var gid = row.game_id

                this._references.games.push(parseInt(gid, 10))

                if (detail) {

                    // In detail mode, return fuller packaged data
                    played.push({
                        game: { id: parseInt(gid, 10) },
                        user: { rating_avg: ratings[gid] ? parseFloat(ratings[gid].rating_avg) : 0 },
                        context: {
                            user: {
                                plays: parseInt(row.plays, 10),
                                play_last: parseInt(row.play_last, 10)
                            }
                        }
                    })

                } else {

                    played.push({
                        g: parseInt(gid, 10),
                        r: ratings[gid] ? parseFloat(ratings[gid].rating_avg) : 0,
                        p: parseInt(row.plays, 10),
                        d: parseInt(row.play_last, 10)
                    })

                }
            }

        }

        return {
            played: played
        }

    }
})
